module.exports = __webpack_public_path__ + "img/logo_1.47f81607.svg";